import { makeStyles } from '@material-ui/core/styles';
import { COLORS, SPACING } from '../constants';

export const useStyles = makeStyles(() => ({
  inpWrapper: {
    marginBottom: SPACING.formGroupGap,
  },
  selWrapper: {
    marginBottom: SPACING.formGroupGap,
  },
  searchSelWrapper: {
    marginBottom: SPACING.formGroupGap,
    '& .MuiAutocomplete-inputRoot': {
      alignItems: 'center',
    },
    '& .MuiAutocomplete-inputRoot.MuiOutlinedInput-root': {
      paddingTop: 4,
      paddingBottom: 4,
    },
    '& .MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
      paddingTop: '4px !important',
      paddingBottom: '4px !important',
      lineHeight: '1.4 !important',
    },
  },
  toggleWrapper: {
    padding: '12px 0',
  },
  toggleLabel: {
    marginLeft: 0,
  },
  sectionHeadingRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: `${SPACING.sectionGap}px 0 14px`,
    paddingBottom: 10,
    borderBottom: `2px solid ${COLORS.primaryLight}`,
  },
  collapsibleToggleButton: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    margin: 0,
    padding: 0,
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    font: 'inherit',
  },
  expandIcon: {
    fontSize: 20,
    color: COLORS.headerText,
  },
}));
